import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { EYesNo } from '../../../../../shared/models/types.enum';
import { FormUtils } from '../../../../../shared/helpers/formUtils';

@Component({
  selector: 'student-history',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './student-history.component.html',
  styleUrl: './student-history.component.css'
})
export class StudentHistoryComponent implements OnInit, OnChanges {

  @Input() parentInterviewData: any;
  @Output() onSaveSection9 = new EventEmitter<any>();

  yesNo = EYesNo;
  studentHistoryForm: FormGroup = new FormGroup([]);

  radioQuestions = [
    {
      id: 'hospitalization',
      questionText: 'Has your child ever been hospitalized? *',
      formControlName: 'hospitalization',
      infoFormControlName: 'hospitalization_information'
    },
    {
      id: 'medical_conditions',
      questionText: 'Has your child had any serious medical conditions? *',
      formControlName: 'medical_conditions',
      infoFormControlName: 'medical_conditions_information'
    },
    {
      id: 'recent_medical_treatment',
      questionText: 'Has your child had any recent medical treatment? *',
      formControlName: 'recent_medical_treatment',
      infoFormControlName: 'recent_medical_treatment_information'
    },
    {
      id: 'prescribed_medications',
      questionText: 'Is your child taking any medications, or has he/she been prescribed any medications that he/she is not taking? *',
      formControlName: 'prescribed_medications',
      infoFormControlName: 'prescribed_medications_information'
    }
  ];

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private formUtils: FormUtils
  ) {}
  
  ngOnInit() {
    this.initializeForm();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['parentInterviewData'] && this.parentInterviewData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};
    
    this.radioQuestions.forEach(question => {
      const defaultValue = this.parentInterviewData && this.parentInterviewData[question.formControlName] !== undefined
                           ? this.parentInterviewData[question.formControlName]
                           : this.yesNo.No;

      group[question.formControlName] = new FormControl(
          String(defaultValue),
          Validators.required
      );
      group[question.infoFormControlName] = new FormControl({ value: this.parentInterviewData?.[question.infoFormControlName] || '', disabled: this.parentInterviewData?.[question.infoFormControlName] ? false : true });
    });

    this.studentHistoryForm = new FormGroup(group);
    this.setupFormChangeHandlers();
  }


  setupFormChangeHandlers() {
    this.radioQuestions.forEach(question => {
      const control = this.studentHistoryForm.get(question.formControlName);
      if (control) {
        control.valueChanges.subscribe(value => {
          const infoControl = this.studentHistoryForm.get(question.infoFormControlName);
          if (infoControl) {
            this.formUtils.handleConditionChange(infoControl, value === this.yesNo.Yes);
          }
        });
      }
    });
  }

  saveStudentHistory(): void {
    if (this.studentHistoryForm.valid) {
        this.onSaveSection9.emit(this.studentHistoryForm.value);
    }
  }

}
